import { getSearchClient } from '@client/modules/discovery/domain/search';
import useGlobals from '@client/monolith/core/composables/use-globals';
import { capturePurchasingException } from '@client/monolith/core/plugins/sentry/helper';
import getIndexName, { IndexName } from '@client/monolith/legacy/services/analytics/algolia/index-name';
import { ProductHit } from '@client/monolith/legacy/types/product';
import { SearchResponse } from 'instantsearch.js';

const formattedProductName = (product: ProductHit, lang: string) => {
  return product.name[lang];
};

export const getProductsHistory = async () => {
  const { lang } = useGlobals();
  try {
    const result = await getSearchClient().search(
      [
        {
          indexName: getIndexName(IndexName.Products),
          params: {
            filters: '(viewed=true) AND sorts=[viewed:desc]',
            facets: [],
            hitsPerPage: 10,
            attributesToRetrieve: ['*'],
            page: 0,
            query: '',
            restrictSearchableAttributes: [],
          },
        },
      ],
      { cacheable: false }
    );
    const searchResult = result?.results[0] as SearchResponse<unknown>;
    return searchResult?.hits?.map((item) => {
      const product = item as ProductHit;
      return {
        ...product,
        name: formattedProductName(product, lang),
      };
    });
  } catch (e) {
    capturePurchasingException(new Error('Error fetching history products', { cause: e }));
    return null;
  }
};
